<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <ClassroomHistory></ClassroomHistory>
        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import ClassroomHistory from '@/components/classroom/history.vue' //购买记录
export default {
    components: {
        top, left, ClassroomHistory
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        }
    }
}
</script>

<style scoped>
#record {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
    position: relative;
}
</style>